import { Outlet } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { getInstructorByIdOptions } from '@drivingdoc/api-client/generated/react-query';
import { InstructorUser } from 'types/instructors';

import useAuthContext from 'hooks/useAuthContext';
import useSchoolContext from 'hooks/useSchoolContext';

import { AccountMenu, Branding, DashboardLayout, NavigationItem } from 'layouts/DashboardLayout';

interface InstructorLayoutProps {
  navItems?: NavigationItem[];
}

export function InstructorLayout({ navItems }: InstructorLayoutProps): JSX.Element {
  const schoolContext = useSchoolContext();
  const { user, userId } = useAuthContext();
  const instructor = useQuery({
    ...getInstructorByIdOptions({
      path: {
        id: userId ?? '',
      },
    }),
    enabled: !!userId,
  });
  const instructorData = instructor.data as InstructorUser | undefined;

  // branding for appbar
  const branding: Branding = {
    title: schoolContext?.name,
    logo: <img src={schoolContext?.logoImage} alt="Logo" style={{ maxHeight: '100%' }} />,
    homeUrl: '/instructor',
  };

  return (
    <DashboardLayout
      navItems={navItems}
      appbarSlots={{
        accountMenu: AccountMenu,
      }}
      appbarSlotProps={{
        appTitle: {
          branding: branding,
        },
        accountMenu: {
          avatarColor: instructorData?.instructor?.calendar_color ?? undefined,
          // avatarImg: 'https://lh3.googleusercontent.com/a/ACg8ocJRW18is3kxbRoPVwNKKTf1-xm6BvQ4odE7GebfXxJM6skaQ1U6=s192-c-mo',
          name: `${user?.first_name ?? ''} ${user?.last_name ?? ''}`,
          email: user?.email,
        },
      }}
    >
      <Outlet />
    </DashboardLayout>
  );
}

export default InstructorLayout;
